import { VictoryPie } from 'victory';
import { View } from 'react-native';
import React from 'react';
import Breakpoints from '../utils/Breakpoints';
import useWindowDimensions from '../utils/useWindowDimensions';
import * as GlobalVariableContext from '../config/GlobalVariableContext';

const getDimensions = width => {
  if (width >= Breakpoints.BigScreen) {
    return { width: 350, height: 350 };
  } else if (width >= Breakpoints.Desktop) {
    return { width: 300, height: 300 };
  } else if (width >= Breakpoints.Laptop) {
    return { width: 250, height: 250 };
  } else {
    return { width: 200, height: 200 };
  }
};

export const Pie = () => {
  const dimensions = useWindowDimensions();
  const pieDimensions = getDimensions(dimensions.width);
  const variables = GlobalVariableContext.useValues();
  const data = variables.EXPENSES;

  return (
    <View style={{ width: pieDimensions.width, height: pieDimensions.height }}>
      <VictoryPie
        padding={10}
        innerRadius={130}
        colorScale={['#5A45FF', '#8FD400', '#1EB7F9', '#FFBF00']}
        labelRadius={({ innerRadius }) => innerRadius + 10}
        style={{
          data: { fontSize: 15 },
          labels: { fontSize: 24, fill: 'black', fontWeight: 'bold' },
        }}
        data={data}
        x={datum => `${datum.value}%`}
        y={'value'}
      />
    </View>
  );
};
